export default "__VITE_PUBLIC_ASSET__6bf44eed__"